// Versión de la app tomada de package.json en tiempo de build (requiere "resolveJsonModule" en tsconfig.json).
// Se usa para invalidar el cache de configuraciones/catálogos (IndexedDB) cuando se despliega una nueva versión.
// IMPORTANTE: bumpear "version" en package.json en cada release para que los usuarios reciban los catálogos actualizados sin borrar el Application Storage manualmente.
import packageJson from '../../../../package.json';

export const APP_VERSION: string = packageJson.version;

// Clave en localStorage donde se persiste la última versión con la que se pobló el cache.
// Se guarda sin encriptar (localStorage plano, no localDB) porque se lee al inicializar IndexedDB,
// antes de que el environment (securityKey) esté disponible.
export const APP_CACHE_VERSION_KEY = 'app_cache_version';
